export function commonSheetValue(sheets, field) {
  const values = sheets.map(sheet => sheet[field] || "");
  return values.every(value => value === values[0]) ? (values[0] || "") : "";
}

export function sheetFieldHint(sheets, field) {
  return new Set(sheets.map(sheet => sheet[field] || "")).size > 1
    ? "Varies by worksheet — see the sheet fields below."
    : "";
}

export function sheetReceiptPayload(payload, group, allItems) {
  return {
    ...payload,
    purchaseOrderId: undefined,
    ptImportJobId: group.ptImportJobId,
    supplierId: group.supplierId,
    agreementType: group.agreementType || undefined,
    storeId: group.storeId || payload.storeId,
    seasonId: group.seasonId || payload.seasonId,
    supplierInvoiceNumber: group.supplierInvoiceNumber.trim() || undefined,
    supplierInvoiceDate: group.supplierInvoiceDate || undefined,
    receivedAt: group.receivedAt || undefined,
    freightAmount: Number(group.freightAmount || 0),
    freightTaxRate: Number(group.freightTaxRate || 0),
    notes: [payload.notes, `PT worksheet: ${group.sheetName}`,
      group.branchName ? `PT branch: ${group.branchName}` : '',
      group.seasonName ? `PT season: ${group.seasonName}` : ''].filter(Boolean).join("\n"),
    items: group.items.map(item => {
      const index = allItems.indexOf(item);
      if (index < 0) throw new Error("A worksheet line is no longer available. Preview the file again.");
      return payload.items[index];
    }),
  };
}

/** Save separately and remember confirmed drafts before attempting posting. */
export async function saveSheetGrns({ groups, payload, allItems, progress, create, post, onSaved, postImmediately }) {
  for (const group of groups) {
    let saved = progress[group.key];
    if (!saved) {
      const grn = await create(sheetReceiptPayload(payload, group, allItems));
      saved = { id: grn.id, number: grn.grnNumber || grn.grn_number || grn.id, posted: false };
      progress[group.key] = saved;
      onSaved(group.key, saved);
    }
    if (postImmediately && !saved.posted) {
      await post(saved.id);
      saved.posted = true;
    }
  }
  return Object.values(progress);
}
